import Link from 'next/link';

import {analyticsTestIds} from '@web-landing/constants/test-ids/analyticsTestIds';

import type {EventName} from '../events';
import {logTmrEvent} from '../helpers/logTmrEvent';

export type AnalyticsLinkProps = {
  event: EventName;
  local?: boolean;
  onClick?: () => void;
} & React.ComponentPropsWithRef<'a'>;

export const AnalyticsLink = ({
  local,
  onClick,
  ...props
}: AnalyticsLinkProps) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }

    logTmrEvent(props.event);
  };

  if (local) {
    return (
      <Link
        {...props}
        onClick={handleClick}
        href={props.href ?? ''}
        data-testid={analyticsTestIds.localAnalyticsLink}
      />
    );
  }

  return (
    <a
      onClick={handleClick}
      data-testid={analyticsTestIds.analyticsLink}
      {...props}
    >
      {props.children}
    </a>
  );
};
